import * as actionType from "./categoryActionType";

const initialState = {
  isLoading: false,
  categories: []
};

export const categoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.FETCH_CATEGORY:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_CATEGORY_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_CATEGORY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                categories: action.payload ? action.payload.data : [],
            };
        default:
            return state;
    }
}